var _circle, _circle2, _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoNotificationsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 106,
  height: 106,
  fill: "none",
  viewBox: "0 0 106 106"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 52.706,
  cy: 52.706,
  r: 52.706,
  fill: "#F3F4F6"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.57,
  cy: 52.843,
  r: 45.796,
  fill: "#E5E7EB"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00B54C",
  strokeLinecap: "round",
  strokeWidth: 0.983,
  d: "m38.982 29.092-.884-7.764m-1.868 9.14-10.81-8.845m10.024 11.498-7.665.885"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.788 65.796a2.16 2.16 0 0 1-1.151-2.833l.79-1.873a2.16 2.16 0 0 1 2.833-1.15l2.054.867c1 .422 2.153-.047 2.575-1.047l7.89-18.686q2.565-6.075 8.219-9.253 5.653-3.176 12.128-2.168l.865-2.05q.773-1.83 2.595-2.57t3.652.033 2.57 2.594-.032 3.652l-.866 2.05q5.239 3.937 6.905 10.204t-.898 12.343l-7.89 18.686a1.965 1.965 0 0 0 1.047 2.576l2.054.867a2.16 2.16 0 0 1 1.15 2.832l-.79 1.873a2.16 2.16 0 0 1-2.833 1.151z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19.655,
  height: 19.655,
  x: 63.552,
  y: 36.957,
  fill: "#00B54C",
  rx: 9.828
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M73.438 53.143q-1.427 0-2.448-.722-1.017-.727-1.565-2.095-.543-1.375-.543-3.309.006-1.935.549-3.29.548-1.364 1.564-2.08 1.023-.715 2.443-.715t2.442.716q1.022.716 1.565 2.078.548 1.363.548 3.291 0 1.94-.548 3.314-.543 1.37-1.565 2.09-1.016.723-2.442.722m0-1.807q1.108 0 1.75-1.091.646-1.097.646-3.228 0-1.409-.295-2.367-.294-.959-.831-1.443a1.82 1.82 0 0 0-1.27-.491q-1.104 0-1.744 1.097-.64 1.09-.647 3.204-.006 1.415.283 2.379.295.965.832 1.455a1.84 1.84 0 0 0 1.276.485M56.901 80.155a7.046 7.046 0 0 1-13.03-5.362z"
})));
export { SvgNoNotificationsIcon as ReactComponent };
export default __webpack_public_path__ + "ab9a58e9ce6d0f3cc652048bf822ef6b.svg";